import { useFormikContext as useBaseFormikContext } from "formik";

export const useFormikContext = () => useBaseFormikContext();

export default useFormikContext;
